// extracted by mini-css-extract-plugin
export default {"wrap":"TaskProcessing_wrap__CbVrG","text":"TaskProcessing_text__kS-ps","wrap__compact":"TaskProcessing_wrap__compact__sWO4x","actions":"TaskProcessing_actions__NpjC0"};